import React, { useState, useEffect } from "react";
import { Alert, Col, Container, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import "react-bootstrap-typeahead/css/Typeahead.css";
import SparkApi from "../api/SparkApi";
import jwt_decode from "jwt-decode";
import { toast, ToastContainer } from "react-toastify";

const UserEdit = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [user, setUser] = useState(
    location.state ? location.state : { isactive: true }
  );
  const [optionUsers, setOptionUsers] = useState([]);
  const [option, setoption] = useState();
  const [selectedUser, setSelectedUser] = useState("");
  const [validated, setValidated] = useState(false);
  const [show, setShow] = React.useState(false);
  const [passwordError, setPasswordError] = useState("");


  useEffect(() => {
    if (user.id) {
      let temp = {};
      temp.value = user.managerid;
      temp.label = user.managername;
      setoption(temp);
    } else {
      let userInfo = jwt_decode(sessionStorage.getItem("token"));
      let temp = {};
      temp.value = userInfo.id;
      temp.label = userInfo.username;
      setoption(temp);
    }
    async function init() {
      const result = await SparkApi.fetchUsers();
      if (result) {
        let ar = [];
        var obj = {};
        obj.value = null;
        obj.label = "--Select--";
        ar.push(obj);
        result.map((item) => {
          if (item.userrole !== "USER") {
            var obj = {};
            obj.value = item.id;
            obj.label = item.username;
            ar.push(obj);
          }
        });
        setOptionUsers(ar);
      } else {
        setOptionUsers([]);
      }
    }
    init();
  }, []);

  const checkRequredFields = () => {
    if (
      user.firstname &&
      user.firstname.trim() !== "" &&
      user.lastname &&
      user.email &&
      user.userrole &&
      user.phone
    ) {
      return false;
    }
    return true;
  };

  const handleCancel = () => {
    navigate(`/users/`);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (e.target.name === "phone") {
      const isValid = /^\d{0,10}$/.test(value);
      if (isValid) {
        setUser((prev) => ({ ...prev, [name]: value }));
      }
    } else if(name === 'password'){
    
      const trimmedValue = e.target.value.replace(/\s/g, "");
      const passwordRegex =
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
      const isValidPassword = passwordRegex.test(trimmedValue);
      if (!isValidPassword) {
        setPasswordError("Password must be 8+ chars with A-Z, a-z, 0-9 & special char.");
      } else {
        setPasswordError(""); // Clear error if valid
      }

      setUser((prev) => ({ ...prev, [name]: value }));
  
    }
    else {
      setUser((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleActive = (e) => {
    setUser({ ...user, [e.target.name]: e.target.checked });
  };


  console.log('user--->',user);
  const handleSubmit = async (e) => {
    try {
        e.preventDefault();

        if(passwordError){
          return
        }

        if (checkRequredFields()) {
            setValidated(true);
        }

        if (!user?.phone) {
            return toast.error("Missing required fields");
        } else if (!/^\d{10}$/.test(user.phone)) {
            return toast.error("Phone number must be exactly 10 digits");
        }

        let result = {};
        if (user.id) {
            result = await SparkApi.updateUserRecord(user);

            if (result.success) {
                toast.success("Record updated successfully");
                setTimeout(() => {
                    navigate("/users", { state: user });
                }, 2500);
            } else {
                return toast.error(result?.errors?.[0]?.msg || "Update failed");
            }
        } else {
            result = await SparkApi.createUser(user);
            if (result.success) {
                toast.success("Record created successfully");
                setTimeout(() => {
                    navigate("/users", { state: result });
                }, 2000);
            } else {
                return toast.error(result?.errors?.[0]?.msg || "Creation failed");
            }
        }
    } catch (error) {
        toast.error(error.message || "An error occurred");
    }
  };

  return (
    <Container className="view-form">
      <Row>
        <Col></Col>
        <Col lg={8} className="pb-1 pt-2">
          <Link className="nav-link" to="/users">
            Home <i className="fa-solid fa-chevron-right"></i>{" "}
            <div style={{ color: "#23468c", display: "inline" }}>Users</div>
          </Link>
        </Col>
        <Col></Col>
      </Row>
      <Row>
        <Col></Col>
        <Col lg={8}>
          <Form className="mt-3" noValidate validated={validated}>
            <Row className="view-form-header align-items-center">
              <Col lg={8}>
                {user.firstname === undefined ? (
                  <h6>Create User</h6>
                ) : (
                  <h6>Edit User</h6>
                )}
              </Col>
              <Col lg={4} className="d-flex justify-content-end">
                <Button className="btn-sm mx-2" onClick={handleSubmit}>
                  Save
                </Button>
                <Button
                  className="btn-sm"
                  variant="danger"
                  onClick={handleCancel}
                >
                  Cancel
                </Button>
              </Col>
            </Row>
            <Row className="ibs-edit-form">
              <Alert variant="danger" show={show} className="error-alert my-4 ">
                Please fill required fields
              </Alert>
              <Row lg={12} className="mb-4">
                <Col lg={6}>
                  <Form.Group className="mx-3" controlId="formBasicFirstName">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicFirstName"
                    >
                      First Name
                    </Form.Label>
                    <Form.Control
                      required
                      type="text"
                      name="firstname"
                      placeholder="Enter firstname"
                      value={user.firstname}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group className="mx-3" controlId="formBasicLastName">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicLastName"
                    >
                      Last Name
                    </Form.Label>
                    <Form.Control
                      //style={{ height: "36px" }}
                      required
                      type="text"
                      name="lastname"
                      placeholder="Enter lastname"
                      value={user.lastname}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col lg={6}>
                  <Form.Group className="mx-3" controlId="formBasicEmail">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicEmail"
                    >
                      Email
                    </Form.Label>
                    <Form.Control
                      style={{ height: "36px" }}
                      type="email"
                      required
                      name="email"
                      placeholder="Enter email"
                      value={user.email}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group className="mx-3" controlId="formBasicPhone">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicPhone"
                    >
                      Phone
                    </Form.Label>
                    <Form.Control
                      style={{ height: "36px" }}
                      required
                      type="text"
                      name="phone"
                      placeholder="Enter phone"
                      value={user.phone}
                      onChange={handleChange}
                    />
                    <Form.Control.Feedback type="invalid">
                      Phone number is required
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                {!user.id ? (
                  <Col lg={6}>
                    <Form.Group className="mx-3" controlId="formBasicpassword">
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicpassword"
                      >
                        Password
                      </Form.Label>
                      <Form.Control
                        style={{ height: "36px" }}
                        required
                        type="password"
                        name="password"
                        placeholder="Enter Password"
                        value={user.password}
                        onChange={handleChange}
                        isInvalid={!!passwordError}
                      />
                      <Form.Control.Feedback type="invalid">
                {passwordError}
              </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                ) : (
                  ""
                )}
                {!user.id ? (
                  <Col lg={6}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">Role</Form.Label>
                      <Form.Select
                        name="userrole"
                        onChange={handleChange}
                        required
                        value={user.userrole}
                      >
                        <option value="">-- Select --</option>
                        <option value="ADMIN">Admin</option>
                        <option value="USER">User</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                ) : (
                  ""
                )}
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">
                      Active
                    </Form.Label>
                    <Form.Check
                      // disabled={user.userrole === 'ADMIN'}
                      inline
                      name="isactive"
                      type="checkbox"
                      value="true"
                      checked={user.isactive === true}
                      id="inline-checkbox-9"
                      onChange={handleActive}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Row>
          </Form>
        </Col>
        <Col></Col>
      </Row>
      <ToastContainer position="top-center" autoClose={2000} theme="light" />
    </Container>
  );
};

export default UserEdit;
